import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Group = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="group icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M2 2C0.895431 2 0 2.89543 0 4V8H24V7C24 5.89543 23.1046 5 22 5H12.8284C12.298 5 11.7893 4.78929 11.4142 4.41421L9.58579 2.58579C9.21071 2.21071 8.70201 2 8.17157 2H2Z"
    />
    <path
      className={pathClass}
      d="M24 10H0V20C0 21.1046 0.89543 22 2 22H22C23.1046 22 24 21.1046 24 20V10Z"
    />
  </svg>
)
